export const COLOR_PICKER_LIST = [
  {
    id: 1,
    rgba: 'rgba(13, 123, 196, 1)',
    key: '13, 123, 196'
  },
  {
    id: 2,
    rgba: 'rgba(100, 62, 255, 1)',
    key: '100, 62, 255'
  },
  {
    id: 3,
    rgba: 'rgba(121, 134, 203, 1)',
    key: '121, 134, 203'
  },
  {
    id: 4,
    rgba: 'rgba(177, 143, 239, 1)',
    key: '177, 143, 239'
  },
  {
    id: 5,
    rgba: 'rgba(192, 107, 219, 1)',
    key: '192, 107, 219'
  },
  {
    id: 6,
    rgba: 'rgba(142, 36, 170, 1)',
    key: '142, 36, 170'
  },
  {
    id: 7,
    rgba: 'rgba(0, 150, 136, 1)',
    key: '0, 150, 136'
  },
  {
    id: 8,
    rgba: 'rgba(11, 128, 67, 1)',
    key: '11, 128, 67'
  },
  {
    id: 9,
    rgba: 'rgba(4, 171, 20, 1)',
    key: '4, 171, 20'
  },
  {
    id: 10,
    rgba: 'rgba(124, 179, 66, 1)',
    key: '124, 179, 66'
  },
  {
    id: 11,
    rgba: 'rgba(192, 202, 51, 1)',
    key: '192, 202, 51'
  },
  {
    id: 12,
    rgba: 'rgba(219, 231, 60, 1)',
    key: '219, 231, 60'
  },
  {
    id: 13,
    rgba: 'rgba(213, 0, 0, 1)',
    key: '213, 0, 0'
  },
  {
    id: 14,
    rgba: 'rgba(246, 59, 59, 1)',
    key: '246, 59, 59'
  },
  {
    id: 15,
    rgba: 'rgba(244, 81, 30, 1)',
    key: '244, 81, 30'
  },
  {
    id: 16,
    rgba: 'rgba(255, 123, 28, 1)',
    key: '255, 123, 28'
  },
  {
    id: 17,
    rgba: 'rgba(240, 147, 0, 1)',
    key: '240, 147, 0'
  },
  {
    id: 18,
    rgba: 'rgba(255, 179, 65, 1)',
    key: '255, 179, 65'
  },
  {
    id: 19,
    rgba: 'rgba(0, 0, 0, 1)',
    key: '0, 0, 0'
  },
  {
    id: 20,
    rgba: 'rgba(102, 118, 132, 1)',
    key: '102, 118, 132'
  },
  {
    id: 21,
    rgba: 'rgba(131, 131, 131, 1)',
    key: '131, 131, 131'
  },
  {
    id: 22,
    rgba: 'rgba(185, 185, 185, 1)',
    key: '185, 185, 185'
  },
  {
    id: 23,
    rgba: 'rgba(121, 85, 72, 1)',
    key: '121, 85, 72'
  },
  {
    id: 24,
    rgba: 'rgba(175, 126, 46, 1)',
    key: '175, 126, 46'
  }
]



// WEBPACK FOOTER //
// ./src/constants/colorPickerList.js